import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ResizingCroppingImagesComponent } from './resizing-cropping-images';
export { ResizingCroppingImagesComponent } from './resizing-cropping-images';
var LyResizingCroppingImageModule = (function () {
    function LyResizingCroppingImageModule() {
    }
    /**
     * @return {?}
     */
    LyResizingCroppingImageModule.forRoot = function () {
        return {
            ngModule: LyResizingCroppingImageModule,
        };
    };
    return LyResizingCroppingImageModule;
}());
export { LyResizingCroppingImageModule };
LyResizingCroppingImageModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                exports: [ResizingCroppingImagesComponent],
                declarations: [ResizingCroppingImagesComponent],
            },] },
];
/**
 * @nocollapse
 */
LyResizingCroppingImageModule.ctorParameters = function () { return []; };
function LyResizingCroppingImageModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyResizingCroppingImageModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyResizingCroppingImageModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/resizing-cropping-images/index.js
// module id = 1383
// module chunks = 31